import config from "../environments/generated.config"
import { getProjectVersion } from "./version"

const { urls } = config

let windowParent = null
let iframeOrigin = null
const validOrigin = new RegExp("https://(.*.)?haytek.com.br", "i")
const serviceName = "carrinho-misto"

export const sendMessage = (message) => {
  /* eslint-disable */
  console.info("haytek-front sendMessage to", iframeOrigin)
  try {
    if (!windowParent) {
      throw new Error("iframe window not initialized")
    }
    windowParent.postMessage(
      {
        ...message,
        serviceName,
      },
      iframeOrigin
    )
  } catch (err) {
    console.error("sendMessage", err)
  }
}

export const setupOrigin = (message) => {
  const { origin } = message
  /* eslint-disable */
  console.info("haytek-front setupOrigin to", origin)
  if (!validOrigin.test(origin)) {
    throw new Error(`invalid_iframe_origin ${origin}`)
  }
  iframeOrigin = origin
}

export const eventFilter = (callback) => (message) => {
  const { data } = message
  if (data.serviceName === serviceName) {
    /* eslint-disable */
    console.info("haytek-front receiveMessage")
    if (data.initializeEvent) {
      setupOrigin(data)
      sendMessage({
        initializeEvent: true,
        projectVersion: getProjectVersion(),
      })
    }
    callback(data)
  }
}

export const startListener = (listenerCallback) => {
  /* eslint-disable */
  console.info("haytek-front startListener")
  try {
    if (!windowParent) {
      throw new Error("iframe window not initialized")
    }
    window.addEventListener("message", eventFilter(listenerCallback), false)
  } catch (err) {
    console.error("startListener", err)
  }
}

export const initializeChannel = (listenerCallback) => {
  try {
    windowParent = window.parent
    if (!windowParent) {
      throw new Error("can't get iframe element window")
    }
    startListener(listenerCallback)
  } catch (err) {
    console.error("initializeChannel", err)
    windowParent = null
    throw err
  }
}
